import videojs from 'video.js';

function copyToClipboard(el, cb) {
  if(!el) return;

  try {
    const selection = window.getSelection();
    const range = document.createRange();

    // * Reset selection
    selection.removeAllRanges();

    // * Set element color 
    el.style.color = "#000";

    // * Add new selection
    range.selectNodeContents(el);
    selection.addRange(range);

    document.execCommand('copy');

    // * Return element color
    el.style.color = "#fff";

    cb && cb();
  } catch (err) {
    console.log('Videojs access code: unable to copy');
  }

}

var utils = {
  copyToClipboard: copyToClipboard
};

export default utils;